if (!customElements.get("m-faq-tabs")) {
  class MFaqTabs extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.tabs = new MinimogTheme.Tabs(this);

      if (Shopify.designMode) {
        // When a merchant clicks a Tab or Question block in the theme editor,
        // switch to that tab (and open the question) so the change is visible.
        this.addEventListener("shopify:block:select", (event) => {
          const block = event.target;
          if (!block || !block.dataset) return;

          const index = Number(block.dataset.index ?? block.dataset.tabIndex ?? 0);
          this.tabs && this.tabs.setActiveTab(index);

          if (block.tagName === "COLLAPSIBLE-TAB" && !block.selected && block.trigger) {
            block.trigger.click();
          }
        });
      }
    }
  }
  customElements.define("m-faq-tabs", MFaqTabs);
}
